<template>
  <div class="container">
    <div class="callback-card">
      <div class="google-logo">
        <svg viewBox="0 0 48 48">
          <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
          <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
          <path fill="#FBBC04" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" />
          <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
        </svg>
      </div>
      <h1 class="page-title">{{ pageTitle }}</h1>
      <p class="app-name">{{ appName }}</p>

      <!-- 載入狀態 -->
      <div v-if="isLoading" class="status-section">
        <div class="loading-spinner"></div>
        <div class="status-message">
          {{ processingMessage }}
        </div>
        <div class="status-description">
          請稍候，我們正在驗證您的登入資訊
        </div>
      </div>

      <!-- 成功狀態 -->
      <div v-if="isSuccess" class="status-section">
        <div class="status-icon status-success">
          ✓
        </div>
        <div class="status-message">
          {{ successMessage }}
        </div>
        <div class="status-description">
          您已成功通過 Google 帳戶驗證
        </div>
        
        <div class="user-info" v-if="userInfo">
          <div class="user-avatar">
            {{ userInfo.avatar }}
          </div>
          <div class="user-name">
            {{ userInfo.name }}
          </div>
          <div class="user-email">
            {{ userInfo.email }}
          </div>
        </div>
        
        <div class="auth-details">
          <div class="auth-row">
            <span class="auth-label">授權碼：</span>
            <span class="auth-value">{{ callbackData.code || '-' }}</span>
          </div>
          <div class="auth-row">
            <span class="auth-label">狀態：</span>
            <span class="auth-value">{{ callbackData.state || '-' }}</span>
          </div>
          <div class="auth-row">
            <span class="auth-label">時間：</span>
            <span class="auth-value">{{ authTime }}</span>
          </div>
        </div>

        <div v-if="scopeItems.length > 0" class="scope-list">
          <div class="scope-title">
            已授權的權限：
          </div>
          <div class="scope-item" v-for="scope in scopeItems" :key="scope.key">
            <div class="scope-icon">✓</div>
            <span>{{ scope.name }}</span>
          </div>
        </div>
      </div>

      <!-- 錯誤狀態 -->
      <div v-if="isError" class="status-section">
        <div class="status-icon status-error">
          ✕
        </div>
        <div class="status-message">
          {{ errorMessage }}
        </div>
        <div class="status-description">
          登入過程中發生錯誤
        </div>
        
        <div class="error-details">
          <div class="error-code">
            錯誤代碼：{{ errorData.code }}
          </div>
          <div class="error-description">
            {{ errorData.description }}
          </div>
        </div>
      </div>

      <!-- 操作按鈕 -->
      <div v-if="showActions" class="actions">
        <button class="btn btn-primary" @click="continueToApp">
          {{ continueButtonText }}
        </button>
        <button v-if="isError" class="btn btn-secondary" @click="retryLogin">
          重新登入
        </button>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/googlecallback.js"  defer></script>
<style scoped src="@/assets/css/googlecallback.css"></style>